import styled from 'styled-components';

export const StyledInput = styled.input`
    // using a BBUI input will disable the increment buttons. Use the Increment component to restore them
    &[type='number'] {
        appearance: textfield;
    }
`;
